const API_URL = 'https://safepass-cors.andresnicolas.com';

function getToken() {
    return localStorage.getItem('token');
}

async function request(method, path, body = null) {
    const headers = { 'Content-Type': 'application/json' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const options = { method, headers };
    if (body) options.body = JSON.stringify(body);

    const res = await fetch(`${API_URL}${path}`, options);
    const data = await res.json().catch(() => ({}));

    if (!res.ok) throw new Error(data.error || 'Something went wrong');
    return data;
}

export const api = {
    register: (body) => request('POST', '/register', body),
    login: (body) => request('POST', '/login', body),
    forgotPassword: (body) => request('POST', '/forgot-password', body),
    resetPassword: (body) => request('POST', '/reset-password', body),
    getUser: () => request('GET', '/user'),
    updateUser: (body) => request('PUT', '/user', body),
    getPasswords: () => request('GET', '/passwords'),
    createPassword: (body) => request('POST', '/passwords', body),
    updatePassword: (id, body) => request('PUT', `/passwords/${id}`, body),
    deletePassword: (id) => request('DELETE', `/passwords/${id}`),
};